import React from 'react'

import Base from '../_Base'

const ChevronDown = (props) => (
  <Base width="40" height="40" viewBox="0 0 40 40" {...props}>
    <path
      d="m29 15-9 9-9-9"
      stroke="currentColor"
      strokeWidth="3"
      fill="none"
      fillRule="evenodd"
    />
  </Base>
)

export default ChevronDown
